module.exports = __webpack_public_path__ + "../resources/img/ic_complete_number_5_lt.1f6295e7.svg";